import React, { useCallback, useState, useRef, useEffect, useMemo } from 'react';
import fscreen from 'fscreen';

//https://github.com/snakesilk/react-fullscreen/issues/63#issuecomment-1191911295

export interface FullScreenHandle {
  active: boolean;
  enter: () => Promise<void>;
  exit: () => Promise<void>;
  node: React.MutableRefObject<HTMLDivElement | null>;
}

export interface FullScreenProps {
  handle: FullScreenHandle;
  children: any;
  onChange?: (state: boolean, handle: FullScreenHandle) => void;
  className?: string;
}

export function useFullScreenHandle(): FullScreenHandle {
  const [active, setActive] = useState<boolean>(false);
  const node = useRef(document.body);

  useEffect(() => {
    const handleChange = () => {
      setActive(fscreen.fullscreenElement === document.body);
    };
    fscreen.addEventListener('fullscreenchange', handleChange);
    return () => fscreen.removeEventListener('fullscreenchange', handleChange);
  }, []);

  const enter = useCallback(() => {
    if (fscreen.fullscreenElement) {
      return fscreen.exitFullscreen().then(() => {
        return fscreen.requestFullscreen(document.body);
      });
    } else if (document.body) {
      return fscreen.requestFullscreen(document.body);
    }
  }, []);

  const exit = useCallback(() => {
    if (fscreen.fullscreenElement === document.body) {
      return fscreen.exitFullscreen();
    }
    return Promise.resolve();
  }, []);

  return useMemo(
    () => ({
      active,
      enter,
      exit,
      node: node as any
    }),
    [active, enter, exit]
  );
}
